import React, { useContext } from 'react'
import { util } from '../../../util'

import { LanguageContext } from '../../../context/LanguageContext'

import TableCell from './TableCell'
import TableIconCell from './TableIconCell'
import TableActionCell from './TableActionCell'
import TableRow from './TableRow'
import TableHeadCell from './TableHeadCell'
import TablePagination from './TablePagination'
import TableNoResults from './TableNoResults'
import TableBody from './TableBody'
import TableHead from './TableHead'
import EnhancedTableHead from './EnhancedTableHead'

const Table = ({ className, size, stickyHead, children, ...rest }) => {
    //RtL Support
    const { rtl } = useContext(LanguageContext)

    //Render
    return (
        <table
            className={util.joinClasses('table', size, stickyHead, className, rtl && 'rtl')}
            {...rest}
        >
            {children}
        </table>
    )
}

Table.EnhancedTableHead = EnhancedTableHead
Table.ActionCell = TableActionCell
Table.Body = TableBody
Table.Cell = TableCell
Table.Head = TableHead
Table.HeadCell = TableHeadCell
Table.IconCell = TableIconCell
Table.NoResults = TableNoResults
Table.Pagination = TablePagination
Table.Row = TableRow

export default Table
